import { CATEGORIE_TO_TRANSFERT } from '@/configuration/role/roleManagerConf';

function getIcon(vm) {
  let icon = null;
  if (vm.$router && vm.$router.currentRoute && vm.$router.currentRoute.name) {
    const currentRoute = vm.$router.currentRoute.name;
    const routeSplit = currentRoute.split('.');
    // Ajout de CATEGORIE_TO_TRANSFERT pour palier au déplacement de certains modules
    const isTransfered = CATEGORIE_TO_TRANSFERT
      .find((cat) => cat.moduleCible === routeSplit[1] && cat.categorieCible === routeSplit[2]);
    routeSplit[1] = isTransfered?.moduleDestination ?? routeSplit[1];
    switch (routeSplit[1]) {
      case 'bodac':
        icon = '/static/img/Gestion%20commerciale.svg';
        break;
      case 'logistique':
        icon = '/static/img/Logistique.svg';
        break;
      case 'gabed':
        icon = '/static/img/Patrimoine.svg';
        break;
      case 'comptabilite':
        icon = '/static/img/Comptabilite.svg';
        break;
      case 'parametrage':
        icon = '/static/img/affixe2.svg';
        break;
      case 'baux':
        icon = '/static/img/Baux.svg';
        break;
      case 'presse':
        icon = '/static/img/presse.svg';
        break;
      case 'stock':
        icon = '/static/img/Stock.svg';
        break;
      case 'achat':
        icon = '/static/img/Achat.svg';
        break;
      default:
        icon = '/static/img/affixe2.svg';
    }
  }
  return icon;
}

export default {
  methods: {
    setLogo() {
      const icon = getIcon(this);
      if (icon) {
        const link = document.createElement('link');
        link.id = 'dynamic-favicon';
        link.rel = 'shortcut icon';
        link.href = icon;
        if (document.getElementById('dynamic-favicon')) {
          document.head.removeChild(document.getElementById('dynamic-favicon'));
        }
        document.head.appendChild(link);
      }
    },
    setInformationPage(newTitle) {
      if (newTitle) document.title = newTitle;
      this.setLogo();
    },
  },
};
